// react
import React from "react"
import { connect } from "react-redux"
import DocumentTitle from "react-document-title"
// app
import { list, deletePerson, clearProfiles } from "actions/profiles/actions.js"
import ProfileList from "components/profiles/List"


class Profiles extends React.Component {
    constructor(props) {
        super()

        this.state = { offset: 0 }
        this.delete = (id) => this.props.deletePerson(id)
        this.showMore = this.showMore.bind(this)
    }

    componentDidMount() {
        this.props.clearProfiles()
        this.props.getProfiles()
    }

    showMore() {
        if (this.props.count <= this.props.profiles.size) return
        
        let { offset } = this.state
        offset += 10
        this.props.getProfiles(offset)
        this.setState({ offset })
    }

    render() {
        return (
            <DocumentTitle title="Profiles">
                <div className="page">
                    <div className="row">
                        <div className="col-xs-12">
                            <ProfileList
                                count={ this.props.count }
                                profiles={ this.props.profiles }
                                onRemove={ this.delete }
                                onShowMore={ this.showMore }
                            />
                        </div>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearProfiles: () => dispatch(clearProfiles()),
        getProfiles: (offset) => dispatch(list(offset)),
        deletePerson: (id) => dispatch(deletePerson(id))
    }
}

function mapStateToProps(state) {
    return {
        count: state.profiles.get("count", 0),
        profiles: state.profiles.get("data")
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Profiles)


/** WEBPACK FOOTER **
 ** ./src/containers/Profiles/profiles.js
 **/